import { render, staticRenderFns } from "./EmailAndCoinCard.vue?vue&type=template&id=5f8b0701&"
import script from "./EmailAndCoinCard.vue?vue&type=script&lang=js&"
export * from "./EmailAndCoinCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports